import { render } from "./IconRestaurant.vue?vue&type=template&id=5149af61"
import script from "./IconRestaurant.vue?vue&type=script&lang=js"
export * from "./IconRestaurant.vue?vue&type=script&lang=js"

import exportComponent from "../../../../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__